module.exports = __webpack_public_path__ + "img/MyCommission.5b6df603.png";